import { FFI } from '../ffi/index';
import { If, Relation } from '@cotera/era';

export const SinkTooling = (cursors: Relation) =>
  cursors.select((t) => ({
    ...t.star(),
    set_cursor: If(t.attr('cotera_stable_id').isNotNull(), {
      then: FFI.setCursor({
        entityId: t.attr('entity_id'),
        detectedAt: t.attr('detected_at_time'),
        sinkId: t.attr('sink_id'),
        streamId: t.attr('event_stream_id'),
        coteraStableId: t.attr('cotera_stable_id'),
      }),
    }),
    pause: FFI.pause({
      entityId: t.attr('entity_id'),
      sinkId: t.attr('sink_id'),
      streamId: t.attr('event_stream_id'),
    }),
  }));
